import Component from 'vue-class-component'
import {Action, Getter, Mutation} from "vuex-class";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import FeedbackComponent from "@/components/base/FeedbackComponent";


@Component({})
export default class MembersProcessesComponent extends FeedbackComponent {

    private FETCH_MEMBER_PROCESSES: string = "getMembersProcesses";
    private FETCH_PROCESS_STATUSES: string = "getProcessStatuses";
    private UPDATE_MEMBER_PROCESS: string = "updateMemberProcess";

    @Action("getMembersProcesses", StoreNamespace.MEMBERS) getMembersProcesses: any;
    @Action("getProcessStatuses", StoreNamespace.MEMBERS) getProcessStatuses: any;
    @Action("updateMemberProcess", StoreNamespace.MEMBERS) updateMemberProcess: any;
    @Getter("processStatuses", StoreNamespace.MEMBERS) processStatuses: any
    @Mutation("setProcessStatuses", StoreNamespace.MEMBERS) setProcessStatuses: any

    private membersProcesses: Array<any> = []
    private isHandled: boolean = false
    private showModal: boolean = false
    private selectedMessage: any = null

    mounted() {
        this.getMembersProcesses({requestorCallback: this})
    }

    onProcessRowClick(data: any) {
        this.showModal = true
        this.getProcessStatuses({requestorCallback: this})
        this.selectedMessage = data
    }

    onSaveResponse() {
        this.updateMemberProcess({
            pathVariable: this.selectedMessage.id,
            requestBody: {
                id: this.selectedMessage.id,
                processStatus: this.selectedMessage.status,
                remarks: this.selectedMessage.remarks
            }, requestorCallback: this
        })
    }

    onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
        switch (requestName) {
            case this.FETCH_MEMBER_PROCESSES:
                this.membersProcesses = data
                break
            case this.FETCH_PROCESS_STATUSES:
                this.setProcessStatuses(data)
                break
            case this.UPDATE_MEMBER_PROCESS:
                this.getMembersProcesses({requestorCallback: this})
                this.showModal = false
                break
            default:
                break
        }
    }

    private jsonHref(jonSource: any): string {
        return 'data:text/json;charset=utf-8,' + encodeURIComponent(jonSource)
    }
}


